import React from 'react';
import PropTypes from 'prop-types';

const FormValidationMessage = ({ errorMessage }) => <p className='error-message'>{ errorMessage }</p>;

FormValidationMessage.propTypes = {
    errorMessage: PropTypes.string,
};

export default FormValidationMessage;
